import Typography from '@/src/components/ui/typography';
import Image from '@/src/components/Image';
import { FC } from 'react';
import Container from '@/src/components/ui/container';
import { IDepartment } from '../services/types';
import { useLocale } from 'next-intl';
import RenderDestination from './RenderDestination';

type Props = {
  data: IDepartment[];
  branchId?: number;
};

const RenderDepartment: FC<IDepartment & { branchId?: number }> = ({
  ArabicImage,
  EnglishImage,
  ArabicName,
  EnglishName,
  Destination,
  branchId,
}) => {
  const locale = useLocale();
  const isArabic = locale === 'ar';
  const Name = isArabic ? ArabicName : EnglishName;
  const ImageRender = isArabic ? ArabicImage : EnglishImage;
  return (
    <RenderDestination destination={Destination} branchId={branchId}>
      <div className="group relative cursor-pointer space-y-2 transition-transform duration-200 hover:scale-105 active:scale-95">
        <div className="relative aspect-square overflow-hidden rounded-full shadow-2xs">
          <Image
            src={ImageRender}
            alt={Name}
            className="object-cover"
            fill
            sizes="(min-width: 1300px) 143px, (min-width: 1160px) calc(15.83vw - 38px), (min-width: 1060px) calc(17.5vw - 32px), (min-width: 1020px) calc(400vw - 4007px), (min-width: 940px) calc(10vw - 23px), (min-width: 860px) calc(10vw - 14px), (min-width: 780px) calc(15vw - 48px), (min-width: 700px) calc(13.33vw - 22px), (min-width: 620px) calc(15vw - 22px), (min-width: 540px) calc(21.67vw - 48px), (min-width: 460px) calc(18.33vw - 13px), (min-width: 380px) calc(26.67vw - 32px), calc(28.33vw - 16px)"
          />
        </div>
        <Typography
          variant={'caption'}
          component={'h3'}
          align={'center'}
          weight={'semibold'}
          lineClamp={2}
          className="group-hover:text-primary px-2 transition-colors"
        >
          {Name}
        </Typography>
      </div>
    </RenderDestination>
  );
};

export const Department: FC<Props> = ({ data, branchId }) => {
  return (
    <Container className="grid grid-cols-[repeat(auto-fill,minmax(60px,1fr))] gap-4 lg:grid-cols-[repeat(auto-fill,minmax(124px,1fr))]">
      {data.map((item) => (
        <RenderDepartment {...item} branchId={branchId} key={item.Id} />
      ))}
    </Container>
  );
};
